import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    download:'/download',
    domain : '/api',
    version:'1.2.1',
  },
  mutations: {

  },
  actions: {

  }
})
